export default __webpack_public_path__ + "static/media/me.d593e259.jpg";